import { Chip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { kycv2SessionStatusColors } from '../../kycv2.enums'

export const SessionStatusBadge = ({ status }) => {
  const { t } = useTranslation(['common'])

  if (!status) return <span>---</span>

  const colors = kycv2SessionStatusColors[status] || { bg: '#9e9e9e', color: '#ffffff' }

  // Map status to translation key
  const statusTranslationMap = {
    'Not Started': t('common:notStarted'),
    'In Progress': t('common:inProgress'),
    'In Review': t('common:inReview'),
    'Approved': t('common:approved'),
    'Declined': t('common:declined')
  }

  const translatedStatus = statusTranslationMap[status] || status

  return (
    <Chip
      label={translatedStatus}
      size="small"
      sx={{
        backgroundColor: colors.bg,
        color: colors.color,
        fontWeight: 500,
        fontSize: '0.75rem',
      }}
    />
  )
}
